// extracted by mini-css-extract-plugin
export default {"container":"LandingPage_container__5YOtd","description":"LandingPage_description__NFre+","column":"LandingPage_column__9kBkN","quickSelection":"LandingPage_quickSelection__fif8m"};